'use client';

import React from 'react';
import dynamic from 'next/dynamic';

const RoasInner = dynamic(() => import('./RoasByClientChartInner'), { ssr: false });

export default function RoasByClientChart() {
  return <RoasInner />;
}